/* VEXORA — lightweight section behaviour (vanilla JS, no dependencies) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Hero slider ---------- */
  function initHero(root) {
    root.querySelectorAll('[data-vx-hero]').forEach(function (hero) {
      if (hero.dataset.vxReady) return;
      hero.dataset.vxReady = '1';
      var track = hero.querySelector('[data-vx-track]');
      var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-vx-slide]'));
      var prev = hero.querySelector('[data-vx-prev]');
      var next = hero.querySelector('[data-vx-next]');
      var current = hero.querySelector('[data-vx-current]');
      if (!track || !slides.length) return;

      function index() {
        return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      }
      function update() {
        var i = Math.min(Math.max(index(), 0), slides.length - 1);
        if (current) current.textContent = String(i + 1).padStart(2, '0');
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
        hero.dataset.theme = slides[i].classList.contains('vx-hero__slide--light') ? 'light' : 'dark';
        slides.forEach(function (s, n) {
          s.setAttribute('aria-hidden', n === i ? 'false' : 'true');
          s.querySelectorAll('a, button').forEach(function (el) {
            if (n === i) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1');
          });
        });
      }
      function go(i) {
        track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(update, 60);
      }, { passive: true });
      if (prev) prev.addEventListener('click', function () { go(index() - 1); });
      if (next) next.addEventListener('click', function () { go(index() + 1); });
      hero.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') go(index() - 1);
        if (e.key === 'ArrowRight') go(index() + 1);
      });
      window.addEventListener('resize', function () { go(index()); });
      update();
    });
  }

  /* ---------- Before / after ---------- */
  function initCompare(root) {
    root.querySelectorAll('[data-vx-compare]').forEach(function (box) {
      if (box.dataset.vxReady) return;
      box.dataset.vxReady = '1';
      var range = box.querySelector('[data-vx-range]');
      var dragging = false;

      function set(pct) {
        pct = Math.min(100, Math.max(0, pct));
        box.style.setProperty('--vx-pos', pct + '%');
        if (range) range.value = Math.round(pct);
      }
      function fromEvent(e) {
        var r = box.getBoundingClientRect();
        set(((e.clientX - r.left) / r.width) * 100);
      }
      box.addEventListener('pointerdown', function (e) {
        dragging = true;
        box.setPointerCapture && box.setPointerCapture(e.pointerId);
        fromEvent(e);
      });
      box.addEventListener('pointermove', function (e) { if (dragging) fromEvent(e); });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (ev) {
        box.addEventListener(ev, function () { dragging = false; });
      });
      if (range) range.addEventListener('input', function () { set(Number(range.value)); });
    });
  }

  /* ---------- Product highlight ---------- */
  function initProduct(root) {
    root.querySelectorAll('[data-vx-ph]').forEach(function (ph) {
      if (ph.dataset.vxReady) return;
      ph.dataset.vxReady = '1';

      var main = ph.querySelector('.vx-ph__img');
      ph.querySelectorAll('[data-vx-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!main || main.tagName !== 'IMG') return;
          main.src = btn.dataset.src;
          main.srcset = btn.dataset.srcset;
          ph.querySelectorAll('[data-vx-thumb]').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
            if (b === btn) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
          });
        });
      });

      var qty = ph.querySelector('[data-vx-qty]');
      if (qty) {
        var input = qty.querySelector('input');
        qty.querySelector('[data-vx-minus]').addEventListener('click', function () {
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        });
        qty.querySelector('[data-vx-plus]').addEventListener('click', function () {
          input.value = (parseInt(input.value, 10) || 1) + 1;
        });
      }

      var select = ph.querySelector('[data-vx-variant]');
      var price = ph.querySelector('[data-vx-price]');
      var submit = ph.querySelector('[data-vx-submit]');
      if (select) {
        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];
          var available = opt.dataset.available === 'true';
          if (price) {
            var html = '<span class="vx-price">' + opt.dataset.price + '</span>';
            if (opt.dataset.compare) html += '<s class="vx-price vx-price--compare">' + opt.dataset.compare + '</s>';
            price.innerHTML = html;
          }
          if (submit) {
            submit.disabled = !available;
            var label = submit.querySelector('span');
            if (label) label.textContent = available ? 'Add to cart' : 'Sold out';
          }
        });
      }
    });
  }

  /* ---------- Video ---------- */
  function initVideo(root) {
    root.querySelectorAll('[data-vx-video]').forEach(function (fig) {
      if (fig.dataset.vxReady) return;
      fig.dataset.vxReady = '1';
      var btn = fig.querySelector('[data-vx-play]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var frame = fig.querySelector('.vx-video__frame');
        var video = fig.querySelector('video');
        if (video) {
          fig.classList.add('is-playing');
          video.play();
          video.focus();
          return;
        }
        var type = fig.dataset.type;
        var id = fig.dataset.id;
        if (!type || !id) return;
        var src = type === 'youtube'
          ? 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1'
          : 'https://player.vimeo.com/video/' + id + '?autoplay=1';
        var iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.title = btn.getAttribute('aria-label') || 'Video';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        frame.appendChild(iframe);
        fig.classList.add('is-playing');
      });
    });
  }

  /* ---------- Footer accordion (mobile) ---------- */
  var desktop = window.matchMedia('(min-width: 990px)');
  function syncFooter(root) {
    (root || document).querySelectorAll('[data-vx-footer] details').forEach(function (d) {
      if (desktop.matches) d.setAttribute('open', '');
      else if (!d.dataset.vxTouched) d.removeAttribute('open');
    });
  }
  function initFooter(root) {
    root.querySelectorAll('[data-vx-footer] summary').forEach(function (s) {
      if (s.dataset.vxReady) return;
      s.dataset.vxReady = '1';
      s.addEventListener('click', function (e) {
        if (desktop.matches) { e.preventDefault(); return; }
        s.parentElement.dataset.vxTouched = '1';
      });
    });
    syncFooter(root);
  }
  if (desktop.addEventListener) desktop.addEventListener('change', function () { syncFooter(document); });

  function init(root) {
    root = root || document;
    initHero(root);
    initCompare(root);
    initProduct(root);
    initVideo(root);
    initFooter(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('[data-vx-slide]');
    if (!slide) return;
    var track = slide.parentElement;
    track.scrollTo({ left: slide.offsetLeft, behavior: 'auto' });
  });
})();
